import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6l28vptlbv: FaireBrandEntity = {
  token: "b_6l28vptlbv",
  type: "brand",
  name: "Puka Creations",
  avatarUrl:
    "https://cdn.faire.com/fastly/9f015f09810a5bb8102c251079f5961b642a6b14d3493fdc5f7c6328e56876dd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cb4b1c6c31accdc0eca4f7bf1361de559d87e8f0481dd3d178afad298c2c2747.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9f015f09810a5bb8102c251079f5961b642a6b14d3493fdc5f7c6328e56876dd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cb4b1c6c31accdc0eca4f7bf1361de559d87e8f0481dd3d178afad298c2c2747.jpeg",
  location: "Torrance, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.6,
  reviewCount: 154,
  isInsider: true,
  description:
    "Established in 1992, we import and distribute trendy jewelry, gifts, toys, and accessories in the USA.\n\nOur distribution center is in Los Angeles, CA.\n\nWe exclusively work with retailers, distributors, and wholesalers.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:58.256Z",
    importedBy: "entity-db-cli",
  },
};
